import React from "react";
import { useTeamConfig } from "../hooks/useTeamConfig";
import { CircularProgress, Stack } from "@mui/material";

export function RedirectProvider(props: { children: React.ReactNode }) {
  const { redirectConfigs } = useTeamConfig();
  const [isLoading, setIsLoading] = React.useState(true);

  React.useEffect(() => {
    // performing auto navigation if specified in teamConfig
    if (redirectConfigs.internalRedirectUrl) {
      window.location.href = redirectConfigs.internalRedirectUrl;
    }
    setIsLoading(false);
  }, []);

  if (!isLoading) return props.children;
  return (
    <Stack
      width={"100%"}
      height={"100vh"}
      alignItems={"center"}
      justifyContent={"center"}
    >
      <CircularProgress size={"64px"} color="primary" />
    </Stack>
  );
}
